import { InjectionToken } from '@angular/core';

export const CLIENT_TYPE = new InjectionToken<string>('CLIENT_TYPE');

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export const API_BASE_PUBLIC_URL = new InjectionToken<string>(
  'API_BASE_PUBLIC_URL',
);

export const API_BASE_ADMIN_URL = new InjectionToken<string>(
  'API_BASE_ADMIN_URL',
);

export const API_BASE_FILE_URL = new InjectionToken<string>(
  'API_BASE_FILE_URL',
);

export const TRANSLATIONS_BASE_URL = new InjectionToken<string>(
  'TRANSLATIONS_BASE_URL',
);

export const LANDING_THEME_PREVIEW = new InjectionToken<boolean>(
  'LANDING_THEME_PREVIEW',
);

export const ALLOW_PROFILE_PHOTO_CHANGE = new InjectionToken<boolean>(
  'ALLOW_PROFILE_PHOTO_CHANGE',
);

export const ALLOW_APPLICANT_PHOTO_CHANGE = new InjectionToken<boolean>(
  'ALLOW_APPLICANT_PHOTO_CHANGE',
);
